import React, { useState, useEffect } from "react";

const VersionInfo = (props) => {
  const [versionText, setVersionText] = useState("Unknown")
  
  useEffect(() => {
    let isSubscribed = true;
    const fetchVersion = async () => {
      // avoid having to always mock this in testing 
      if (!props.apiService || !props.apiService.get_version) {
        setVersionText('NO API SERVICE PROVIDED');
        return;
      }

      const result = await props.apiService.get_version();
      if (result.ok && isSubscribed) {
        setVersionText(result.version);
      }
		};
    fetchVersion();
    return () => isSubscribed = false;
  }, [props.apiService]);
  
	return (
    <span style={{'display': 'none'}}>
      MyAccount version {versionText}
    </span>
	);
};

export default VersionInfo;
